export default function buildFullName(firstName: string, lastName: string) {
  if (lastName) {
    return `${firstName} ${lastName}`;
  }

  return firstName;
}
